/**
 * Lista de rutas y títulos de páginas para la navegación y el uso de títulos dinámicos en la aplicación.
 * Cada objeto contiene la ruta (path) y el título asociado (title).
 * @type {Array<{path: string, title: string}>}
 */
export default [
  {
    path: 'requirement/createTicket/incident',
    title: 'pageTitles.createTicket'
  },
  {
    path: 'requirement/createTicket/service',
    title: 'pageTitles.createTicketService'
  },
  {
    path: 'change/create',
    title: 'pageTitles.changeTicket'
  },
  {
    path: 'change/find',
    title: 'pageTitles.searchChange'
  },
  {
    path: 'change/detail/',
    title: 'pageTitles.changeDetail'
  },
  {
    path: 'requirement/find',
    title: 'pageTitles.searchTickets'
  },
  {
    path: 'requirement/re-assign',
    title: 'pageTitles.reassignTicket'
  },
  {
    path: 'requirement/detail/',
    title: 'pageTitles.ticketDetail'
  },
  {
    path: 'requirement/odt/create',
    title: 'pageTitles.newEnablingService'
  },
  {
    path: 'requirement/odt/search',
    title: 'pageTitles.searchEnablingService'
  },
  {
    path: 'informativeModule/clients',
    title: 'pageTitles.informativeModuleClientsAssignedToUser'
  },
  {
    path: 'informativeModule/workForce',
    title: 'pageTitles.informativeModuleWorkforceAssignedToUser'
  },
  {
    path: 'requirement/odt/',
    title: 'pageTitles.enablingServiceDetail'
  },
  {
    path: 'admin/project',
    title: 'pageTitles.projects'
  },
  {
    path: 'admin/createAndConfigUser',
    title: 'pageTitles.users'
  },
  {
    path: 'admin/permissionsAudit',
    title: 'pageTitles.permissionsAudit'
  },
  {
    path: '/admin/UnitsMeasurement',
    title: 'pageTitles.unitsOfMeasurement'
  },
  {
    path: 'admin/status',
    title: 'pageTitles.status'
  },
  {
    path: 'admin/flowBoard',
    title: 'pageTitles.flowBoard'
  },
  {
    path: 'admin/equipmentType',
    title: 'pageTitles.equipmentType'
  },
  {
    path: 'admin/project/create',
    title: 'Proyectos'
  },
  {
    path: '/massiveLoad/ExternalFile',
    title: 'drawer.tickets.bulkLoad'
  },
  {
    path: '/admin/IRFlow',
    title: 'pageTitles.incidentAndRequestFlow'
  },
  {
    path: 'shipping/create',
    title: 'pageTitles.newShipment'
  },
  {
    path: 'admin/kpis',
    title: 'KPIs'
  },
  {
    path: '/admin/formsManagement',
    title: 'pageTitles.formsManagement'
  },
  {
    path: 'admin/AccessLogbook',
    title: 'pageTitles.accessLogbook'
  },
  {
    path: 'shipping/find',
    title: 'pageTitles.shipmentConfirmation'
  },
  {
    path: 'shipping/detail/',
    title: 'pageTitles.shipmentEditing'
  },
  {
    path: 'shipping/reception/detail',
    title: 'pageTitles.shipmentEditing'
  },
  {
    path: 'ubications/map',
    title: 'pageTitles.locationMap'
  },
  {
    path: 'ubications/massiveLoadUbications',
    title: 'pageTitles.massiveLocationLoad'
  },
  {
    path: 'ubications/massiveDeactivate',
    title: 'pageTitles.deactivateLocations'
  },
  {
    path: 'ubications/workForce',
    title: 'pageTitles.workforceLocation'
  },
  {
    path: 'ubications',
    title: 'pageTitles.locations'
  },

  {
    path: 'admin/frecuentlyFailure',
    title: 'pageTitles.failureType'
  },
  {
    path: 'admin/serviceName',
    title: 'pageTitles.serviceName'
  },
  {
    path: 'admin/serviceType',
    title: 'pageTitles.serviceType'
  },
  {
    path: 'admin/ResponsibleType',
    title: 'pageTitles.responsibleType'
  },
  {
    path: 'admin/CABManagement',
    title: 'pageTitles.CABManagement'
  },
  {
    path: '/chatbot',
    title: 'pageTitles.chatbot'
  },
  {
    path: 'admin/clientPriority',
    title: 'pageTitles.clientPriority'
  },
  {
    path: 'admin/serviceClass',
    title: 'pageTitles.serviceClass'
  },
  {
    path: '/Supplies',
    title: 'pageTitles.supplyRegistration'
  },
  {
    path: '/StockSupplies',
    title: 'pageTitles.supplyStock'
  },
  {
    path: '/configurationComponent/massiveLoad',
    title: 'pageTitles.massiveConfigurationComponentLoad'
  },
  {
    path: '/configurationComponent/massiveUpdate',
    title: 'pageTitles.massiveConfigurationComponentUpdate'
  },
  {
    path: '/configurationComponent/Map',
    title: 'pageTitles.configurationComponentMap'
  },
  {
    path: '/configurationComponent',
    title: 'pageTitles.configurationComponents'
  },
  {
    path: 'admin/stores',
    title: 'pageTitles.warehouse'
  },
  {
    path: 'statusCongurationComponents',
    title: 'pageTitles.configurationComponentStatus'
  },
  {
    path: 'admin/ubitacionPriority',
    title: 'pageTitles.locationPriority'
  },
  {
    path: '/admin/brand',
    title: 'pageTitles.brand'
  },
  {
    path: '/admin/postalCodes',
    title: 'pageTitles.postalCodes'
  },
  {
    path: '/admin/calendar',
    title: 'pageTitles.calendars'
  },
  {
    path: '/admin/model',
    title: 'pageTitles.model'
  },
  {
    path: 'admin/reasons',
    title: 'pageTitles.reasons'
  },
  {
    path: 'admin/directions',
    title: 'pageTitles.addresses'
  },
  {
    path: 'admin/area',
    title: 'pageTitles.areas'
  },
  {
    path: 'admin/clasificationTicket',
    title: 'pageTitles.clasifitactionTicket'
  },

  {
    path: 'admin/currency',
    title: 'pageTitles.currency'
  },
  {
    path: 'admin/commentTypes',
    title: 'pageTitles.commentTypes'
  },
  {
    path: 'admin/clientsManagment',
    title: 'pageTitles.clientConfigurationTechnology'
  },
  {
    path: 'admin/audit',
    title: 'pageTitles.audits'
  },
  {
    path: 'assetManagementIT/AuditReport',
    title: 'pageTitles.audits'
  },
  {
    path: 'admin/catalogAudit',
    title: 'pageTitles.auditCatalog'
  },
  {
    path: 'admin/towerModel',
    title: 'common.commonProperties.towerModel'
  },
  {
    path: 'admin/towerType',
    title: 'common.commonProperties.towerType'
  },
  {
    path: 'admin/towerProperty',
    title: 'common.commonProperties.towerProperty'
  },
  {
    path: 'admin/odt/',
    title: 'pageTitles.enablingServiceFlowODT'
  },
  {
    path: 'admin/WarehouseType',
    title: 'pageTitles.warehouseType'
  },
  {
    path: '/admin/directions',
    title: 'pageTitles.addresses'
  },
  {
    path: '/admin/area',
    title: 'pageTitles.areas'
  },
  {
    path: '/admin/commentTypes',
    title: 'pageTitles.commentTypes'
  },
  {
    path: '/admin/regions',
    title: 'pageTitles.regions'
  },
  {
    path: '/admin/states',
    title: 'pageTitles.states'
  },
  {
    path: '/admin/frecuentlyFailure',
    title: 'pageTitles.failureType'
  },
  {
    path: '/admin/serviceType',
    title: 'pageTitles.serviceType'
  },
  {
    path: '/assetManagementIT/workForce/kits/find',
    title: 'pageTitles.workforceCIKits'
  },
  {
    path: '/admin/ubitacionPriority',
    title: 'pageTitles.locationPriority'
  },
  {
    path: '/admin/brand',
    title: 'pageTitles.brand'
  },
  {
    path: '/admin/model',
    title: 'pageTitles.model'
  },
  {
    path: '/admin/profiles',
    title: 'pageTitles.profiles'
  },
  {
    path: '/admin/projects',
    title: 'pageTitles.projects'
  },
  {
    path: '/kits',
    title: 'pageTitles.kits'
  },
  {
    path: '/admin/groups',
    title: 'users.groups'
  },
  {
    path: '/admin/workFlowType',
    title: 'pageTitles.enablingServiceFlowType'
  },
  {
    path: '/admin/componentCondition',
    title: 'pageTitles.componentCondition'
  },
  {
    path: 'admin/invoiceTAG',
    title: 'pageTitles.tagFolioToll'
  },
  {
    path: 'admin/invoiceFuel',
    title: 'pageTitles.fuelFolio'
  },
  {
    path: 'admin/expenseCode',
    title: 'pageTitles.travelExpensesFolio'
  },
  {
    path: 'admin/Indicators',
    title: 'pageTitles.indicators'
  },
  {
    path: '/kitsWarehouse',
    title: 'pageTitles.warehouseKITS'
  },
  {
    path: '/warehousesSupplyInventory',
    title: 'pageTitles.warehouseSupplies'
  },
  {
    path: '/warehousesComponentInventory',
    title: 'pageTitles.warehouseConfigurationComponents'
  },
  {
    path: '/SupplyInventory',
    title: 'pageTitles.supplies'
  },
  {
    path: '/ConfigurationComponentsWarehouse',
    title: 'pageTitles.kitsWarehouse'
  },

  {
    path: '/assetManagementIT/workForce/configComponent/find',
    title: 'pageTitles.workforceConfigurationComponents'
  },
  {
    path: '/assetManagementIT/workForce/supplies/find',
    title: 'pageTitles.workforceSupplies'
  },

  {
    path: '/admin/interventionCodes',
    title: 'pageTitles.interventionCodes'
  },
  {
    path: '/admin/category',
    title: 'pageTitles.category'
  },
  {
    path: '/admin/impact',
    title: 'pageTitles.impact'
  },
  {
    path: '/admin/priority',
    title: 'pageTitles.priority'
  },
  {
    path: '/admin/urgency',
    title: 'pageTitles.urgency'
  },
  {
    path: '/admin/create/criticality',
    title: 'pageTitles.criticality'
  },
  {
    path: 'admin/Escalations',
    title: 'drawer.admin.catalogues.escalations'
  },

  {
    path: '/laboratoryComponentInventory',
    title: 'pageTitles.laboratoryConfigurationComponents'
  },
  {
    path: '/laboratory/bulkReception',
    title: 'pageTitles.bulkReception'
  },
  {
    path: '/shipping/report',
    title: 'pageTitles.shippingReport'
  },
  {
    path: '/notifications',
    title: 'pageTitles.notifications'
  },
  {
    path: '/help/FAQs',
    title: 'pageTitles.faqs'
  },
  {
    path: '/admin/reportCatalogue',
    title: 'pageTitles.reportCatalog'
  },
  {
    path: '/reports',
    title: 'pageTitles.reports'
  },
  {
    path: '/incidentReports/open',
    title: 'pageTitles.openIncidentReports'
  },
  {
    path: '/incidentReports/historical',
    title: 'pageTitles.historicalIncidentReports'
  },
  {
    path: '/exportTicketsReport',
    title: 'pageTitles.ticketExportReport'
  },
  {
    path: '/expenseReport',
    title: 'pageTitles.serviceCostReport'
  },
  {
    path: '/recidivists',
    title: 'pageTitles.recidivistsReports'
  },
  {
    path: '/remoteWork',
    title: 'pageTitles.remoteWork'
  },
  {
    path: '/mayorIncident',
    title: 'pageTitles.mayorIncident'
  },
  {
    path: '/KMDB',
    title: 'pageTitles.KMDB'
  },
  {
    path: '/surveys/new',
    title: 'pageTitles.newSurvey'
  },
  {
    path: '/admin/notification-configurator',
    title: 'pageTitles.notificationConfigurator'
  },
  {
    path: '/admin/notification-configurator/create',
    title: 'pageTitles.notificationConfiguratorCreate'
  },
  {
    path: '/admin/notification-configurator/edit/:id',
    title: 'pageTitles.notificationConfiguratorEdit'
  },
  {
    path: '/admin/notification',
    title: 'pageTitles.notifications'
  },
  {
    path: '/surveys/search',
    title: 'pageTitles.surveySearch'
  },
  {
    path: '/admin/solutionTopics',
    title: 'pageTitles.solutionTopics'
  },
  {
    path: 'admin/solutionType',
    title: 'pageTitles.solutionType'
  },
  {
    path: '/surveys/report',
    title: 'pageTitles.surveyReport'
  },
  {
    path: '/changeTypes',
    title: 'pageTitles.changeTypesDrawerName'
  },
  {
    path: '/statesOfChange',
    title: 'pageTitles.stagesOfChanges'
  },
  {
    path: '/admin/stagesAndStatuses',
    title: 'pageTitles.stagesAndStatuses'
  },
  {
    path: '/admin/statusesOfTasks',
    title: 'admin.statusesOfTasks.drawerName'
  },
  {
    path: '/solutions/find',
    title: 'drawer.solutions.solutionsSearch'
  },
  {
    path: '/solutions/create',
    title: 'drawer.solutions.newSolution'
  },
  {
    path: 'solutions/detail/',
    title: 'drawer.solutions.solutionDetail'
  },
  {
    path: '/admin/flowOfChanges',
    title: 'pageTitles.flowOfChanges'
  },
  {
    path: '/problem/search',
    title: 'pageTitles.problemSearch'
  },
  {
    path: '/problem/create',
    title: 'pageTitles.newProblem'
  },
  {
    path: '/problem/detail/',
    title: 'pageTitles.problemDetails'
  },
  {
    path: '/problem/update/',
    title: 'pageTitles.problemUpdate'
  },
  {
    path: '/admin/HierarchyLevels',
    title: 'pageTitles.hierarchyLevels'
  },
  {
    path: 'admin/hierarchicalStructure',
    title: 'pageTitles.organigrama'
  },
  {
    path: 'admin/massiveHierarchicalStructureUpdate',
    title: 'pageTitles.massiveHierarchicalStructureUpdate'
  },
  {
    path: 'admin/tasktemplate',
    title: 'drawer.tasks.tasktemplate'
  },
  {
    path: '/admin/problem/statusFlows',
    title: 'pageTitles.statusFlows'
  },
  {
    path: '/admin/problem/status',
    title: 'pageTitles.statusFlowsProblems'
  },
  {
    path: '/admin/catalogs/problem-templates/edit',
    title: 'pageTitles.problemTemplatesEdit'
  },
  {
    path: '/admin/catalogs/problem-templates/create',
    title: 'pageTitles.problemTemplatesCreate'
  },
  {
    path: '/admin/catalogs/problem-templates',
    title: 'pageTitles.problemTemplates'
  },

  {
    path: '/release/create',
    title: 'pageTitles.newRelease'
  },
  {
    path: '/release/find',
    title: 'pageTitles.searchRelease'
  },
  {
    path: '/admin/release/statusFlows',
    title: 'pageTitles.statusFlowsRelease'
  },
  {
    path: '/admin/release/status',
    title: 'pageTitles.statusRelease'
  },
  {
    path: '/release/detail',
    title: 'pageTitles.releaseDetail'
  },
  {
    path: '/admin/problem/automaticProblemDetection',
    title: 'pageTitles.automaticProblemDetection'
  },
  {
    path: '/admin/problem/causes-catalog',
    title: 'pageTitles.causesCatalog'
  },
  {
    path: '/admin/problem/expert-committees-catalog',
    title: 'pageTitles.expertCommitteesCatalog'
  },
  // 1. ES EL DEFAULT
  // 2. DENTRO DE ESTE PATH 'src\layouts\Main\index.tsx'
  // AL USAR UN INCLUDES TOMA EL PRIMERO QUE ENCUENTRA, Y ESE PRIMERO SIEMPRE ES '/' QUE ES EL DASHBOARD
  {
    path: '/',
    title: 'pageTitles.dashboard'
  }
];
